import { createRequest } from '@widget-kit/container';

function initSizePlugin(container, config) {
    if (config === void 0) { config = {}; }
    var iframe = container.iframe, handle = container.handle;
    function setSize(size) {
        size.width && (iframe.style.width = size.width);
        size.height && (iframe.style.height = size.height);
        size.maxWidth && (iframe.style.maxWidth = size.maxWidth);
        size.maxHeight && (iframe.style.maxHeight = size.maxHeight);
    }
    if (config.initialSize) {
        setSize(config.initialSize);
    }
    handle("plugins.size.setSize" /* setSize */, function (_, size) {
        setSize(size);
    });
}
function setSize(size) {
    return createRequest("plugins.size.setSize" /* setSize */, size);
}

export { initSizePlugin, setSize };
//# sourceMappingURL=index.esm.js.map
